export function newThreadId(): string {
  return crypto.randomUUID()
}
